import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '../server/layout/Stack/index';
import { Heading } from '../server/typography/Heading/index';
import { Body } from '../server/typography/Body/index';
import { Numeric } from '../server/typography/Numeric/index';
import { Card } from '../Card/Card';
import { Icon } from '../system/icons';
import { TONE } from '../system/tone';
export function Stat({ icon, value, label, meta, size = 'md', tone, onDark, interactive, pad = 'compact', style, }) {
    const numColor = onDark ? 'var(--background)' : (tone ? TONE[tone].ink : 'var(--foreground)');
    const labelColor = onDark ? 'rgba(255 255 255 / 85%)' : undefined;
    const metaColor = onDark ? 'rgba(255 255 255 / 60%)' : undefined;
    const inner = (_jsxs(Stack, { gap: icon ? "sm" : "xs", children: [icon && (_jsx(Icon, { size: "sm", color: tone ? TONE[tone].ink : (onDark ? 'var(--on-dark-accent)' : 'var(--foreground)'), children: icon })), _jsx(Numeric, { size: size === 'lg' ? 'title' : 'title-sm', style: { color: numColor }, children: value }), _jsx(Heading, { level: 5, style: { color: labelColor }, children: label }), meta && _jsx(Body, { size: "sm", as: "span", style: { color: metaColor ?? 'var(--muted-foreground)' }, children: meta })] }));
    if (!tone) {
        return (_jsx("div", { style: { ...(interactive ? { cursor: 'pointer' } : null), ...style }, children: inner }));
    }
    return _jsx(Card, { tone: tone, pad: pad, interactive: interactive, style: style, children: inner });
}
//# sourceMappingURL=Stat.js.map